import styled from "styled-components";
import { FiMail } from "react-icons/fi";
import { Link } from "react-router-dom";

export const ContactBarContainer = styled.div`
  background-color: ${({ isLight }) => (isLight ? "#fefefa" : "#2b2e46")};
  display: flex;
  justify-content: center;
  align-items: center;

  margin-top: -20px;
  padding-bottom: 85px;
  }

  @media screen and (max-width: 856px) {
    margin-top: -70px;
    padding-bottom: 85px;
  }

  @media screen and (max-width: 856px) {
    margin-top: -70px;
    padding-bottom: 85px;
  }

  @media screen and (max-width: 456px) {
    margin-top: -50px;
    padding-bottom: 70px;
  }
`;

export const ContactBarBtnLink = styled(Link)`
  font-size: 1.5rem;
  font-weight: bold;
  padding: 1.5rem 5rem;

  border-radius: 5px;
  background-color: #96a9fe;
  white-space: nowrap;

  color: #fefefa;

  outline: none;
  border: none;
  cursor: pointer;

  transition: all 0.2s ease-in-out;
  text-decoration: none;

  @media screen and (max-width: 856px) {
    padding: 1.2rem 3rem;
  }

  @media screen and (max-width: 456px) {
    font-size: 1rem;
    padding: 1rem 3rem;
  }
  &:hover {
    transition: all 0.2s ease-in-out;
    background-color: #ffb400;
  }
`;

export const MailIcon = styled(FiMail)`
  margin-right: 10px;
  color: #fefefa;
  font-size: 1.5rem;

  @media screen and (max-width: 456px) {
    font-size: 1rem;
  }
`;
